import { Component, OnInit, Input } from '@angular/core';
import { EChartsOption } from 'echarts';

@Component({
    selector: 'line-chart',
    templateUrl: './line-chart.component.html',
    styleUrls: ['./line-chart.component.scss'],
    standalone: false
})
export class LineChartComponent implements OnInit {

  @Input() xAxisCategories : any[] = [];
  @Input() yAxisCategories : any[]= [];
  chartOptions : EChartsOption = {};

  constructor() { }

  ngOnInit(): void {
    try{
      if(this.xAxisCategories.length==0 || this.yAxisCategories.length==0){
        this._setDummyOptions();
      }
      else{
        this.setOptions();
      }
    }catch (err){
      console.log(err);
    }
  }

  private _setDummyOptions(){
    this.chartOptions = {
      tooltip:{},
      grid:{
        left: 40,
      },
      xAxis: [{
        type:'category',
        data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'], //this.xAxisCategories,
        axisTick : {alignWithLabel:true} //does product want this UI detail
        
      }],
      yAxis: [{
        type:'value',
      }],
      series: [{
        data: ['50', '50', '50', '50', '50', '50'],
        type: 'line',
        color: '#B044BF',
        symbol:'circle',
        symbolSize: 6,
        connectNulls:true
      }]
    }
  }

  setOptions(){
    this.chartOptions = {
      tooltip:{},
      grid:{
        left: 90,
      },
      xAxis: [{
        type:'category',
        data: this.xAxisCategories,
        axisTick : {alignWithLabel:true} //does product want this UI detail
        
      }],
      yAxis: [{
        type:'value',
      }],
      series: [{
        data: this.yAxisCategories,
        type: 'line',
        color: '#B044BF',
        symbol:'circle',
        symbolSize: 6,
        connectNulls:true
      }]
    }
  }

}
